import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=43bc7bde&scoped=true&"
var script = {}
import style0 from "./Resources.vue?vue&type=style&index=0&id=43bc7bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc7bde",
  null
  
)

export default component.exports